(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certnz-article"]) return;
  try {
    
document.querySelectorAll('[data-certnz-article]').forEach((root) => {
  const body = root.querySelector('[data-certnz-article-body]');
  const toc = root.querySelector('[data-certnz-article-toc]');
  const list = root.querySelector('[data-certnz-article-toc-list]');
  if (!body || !toc || !list) return;

  const headings = [...body.querySelectorAll('h2')]
    .filter((heading) => heading.textContent.trim() !== '');
  if (headings.length < 3) return;

  const used = new Set();
  headings.forEach((heading, index) => {
    const base = heading.textContent
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || `section-${index + 1}`;
    let id = heading.id || base;
    let suffix = 2;

    while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
      id = `${base}-${suffix}`;
      suffix += 1;
    }

    heading.id = id;
    used.add(id);

    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });

  toc.hidden = false;
});

  } catch(e) { console.error(e); }
})();
})();
